<template>
  <b-card-code class="mt-2 principal notificaciones-body">
    <div style="height: inherit">
      <div class="email-app-list">
        <!-- Lista de Notificaciones -->
        <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="email-user-list scroll-area"
        >
          <ul class="email-media-list pl-0 m-0">
            <b-media
              v-for="notificacion in notificaciones"
              :key="notificacion.token"
              tag="li"
              no-body
              class="pt-3 pb-3 pl-2"
              :class="{ 'notificacion-leida': notificacion.estado !== 'LEI' }"
              style="border-bottom: 3px solid #ebebeb; cursor: pointer;"
              @click.prevent="marcarComoLeida(notificacion)"
            >
              <!-- Avatar/Icono -->
              <b-media-aside class="media-left mr-50">
                <b-avatar
                  class="avatar"
                  size="40"
                  variant="light-success"
                >
                  <feather-icon icon="ExternalLinkIcon" />
                </b-avatar>
              </b-media-aside>

              <!-- Contenido -->
              <b-media-body>
                <div class="mail-details">
                  <div class="mail-meta-item">
                    <small class="text-muted">{{ notificacion.fechaGeneracion }}</small>
                  </div>
                  <div class="mail-items">
                    <h5 class="mb-25" :class="{ 'font-weight-bold': notificacion.estado === 'NOL' }">
                      {{ notificacion.notificacion.titulo }}
                    </h5>
                  </div>
                </div>

                <div class="mail-message">
                  <p class="mb-0">
                    {{ notificacion.notificacion.contenido }}
                  </p>
                </div>
              </b-media-body>
            </b-media>
          </ul>
        </vue-perfect-scrollbar>
      </div>
    </div>

    <!-- 📌 Paginación -->
    <b-col cols="12" class="mb-2">
      <b-pagination
        v-if="notificaciones.length > 0"
        v-model="currentPageModificado"
        :total-rows="totalRows"
        :per-page="perPage"
        first-number
        last-number
        :small="true"
        class="mb-0"
        align="center"
        prev-class="prev-item"
        next-class="next-item"
        @change="prueba"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </b-col>
  </b-card-code>
</template>

<script>
import {
  BRow, BCol, BCardTitle, BOverlay, BForm, BFormGroup, BFormInput,
  BInputGroup, BFormTextarea, BButton, BAvatar, BMedia, BMediaAside,
  BMediaBody, BLink, BPagination
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import BCardCode from '@core/components/b-card-code'
import axios from "@axios"
import $ from "jquery"

export default {
  components: {
    BButton, BFormTextarea, BInputGroup, BFormInput, BFormGroup, BForm,
    BCardTitle, BCardCode, BRow, BCol, BOverlay, VuePerfectScrollbar,
    BAvatar, BMedia, BMediaAside, BMediaBody, BLink, BPagination
  },
  data() {
    return {
      notificaciones: [],
      perfectScrollbarSettings: { maxScrollbarLength: 150 },
      perPage: 10,
      totalRows: 1,
      currentPage: 1,
      currentPageModificado: 1,
    }
  },
  created() {
    this.comprobarPermisos()
    $("#btn-excel, #btn-pdf, #btn-print, #eliminar-viajes").remove()
  },
  methods: {
    obtenerNotificaciones(desde = 0, hasta = 10, pagina_actual = 1) {
      axios.post("api", {
        query: `query getNotificacionOrdenUsuario($desde: Int!, $hasta: Int!){
          getNotificacionOrdenUsuario(desde: $desde, hasta: $hasta){
            notificaciones{
              notificacion { token titulo contenido url }
              token
              estado
              fechaGeneracion
            }
            total
            status
            message
          }
        }`,
        variables: { desde, hasta }
      }).then(response => {
        if (response.status === 200 &&
            response.data.data.getNotificacionOrdenUsuario.status === "success") {
          this.notificaciones = response.data.data.getNotificacionOrdenUsuario.notificaciones
          this.totalRows = response.data.data.getNotificacionOrdenUsuario.total
          this.currentPageModificado = pagina_actual
        }
      })
    },

    marcarComoLeida(notificacion) {
      // Si ya está leída, solo redirige
      if (notificacion.estado === 'LEI') {
        window.location.href = notificacion.notificacion.url
        return
      }
      // Si está "NOL" (no leída) -> marcar como leída antes de redirigir
      axios.post("api", {
        query: `mutation {
          leerNotificacion(tokenNotificacion: "${notificacion.token}") {
            status
            message
          }
        }`
      }).then((response) => {
        if (response.status === 200 &&
            response.data.data.leerNotificacion.status === "success") {
          // Cambiar el estado en UI
          notificacion.estado = 'LEI'
        }
      }).catch(err => {
        console.error("Error al marcar como leída:", err)
      }).finally(() => {
        window.location.href = notificacion.notificacion.url
      })
    },

    comprobarPermisos() {
      if (localStorage.getItem("permisos").indexOf("not_not_orden") === -1) {
        this.$router.push({ name: "not-permitted" })
      }
    },

    prueba(value) {
      const pagina_actual = value
      const limite_superior = value * this.perPage
      const limite_inferior = (value - 1) * this.perPage
      this.obtenerNotificaciones(limite_inferior, limite_superior, pagina_actual)
    },
  },
  mounted() {
    this.obtenerNotificaciones()
  }
}
</script>

<style>
.principal .card-header {
  display: none !important;
}

.notificaciones-body .card-body {
  padding: 0!important;
}

/* 📌 Notificación leída */
.notificacion-leida {
  background-color: #e4e5e5 !important;
}

/* 📌 Hover sobre cada notificación */
.email-media-list .media:hover {
  background-color: #f5f6f7 !important;
  border-left: 4px solid #1877f2 !important; /* azul estilo Facebook */
  padding-left: 12px;
  transition: background-color 0.2s ease;
}
</style>
